import { config } from '@/config';
import type { PageRobotsPolicy } from '@/ui/hooks/usePageTitle';

export type PublicSiteVariant = 'current' | 'discoverability';
export type PublicSitePageKey = 'docs' | 'features' | 'plans';
export type PublicSiteConfig = {
  seoEnabled: boolean;
  variant: PublicSiteVariant;
  pages: Record<PublicSitePageKey, boolean>;
};

export const publicSiteConfig: PublicSiteConfig = config.publicSite;

export const isPublicSiteSeoEnabled = (): boolean => publicSiteConfig.seoEnabled;

export const isPublicSitePageEnabled = (page: PublicSitePageKey): boolean =>
  publicSiteConfig.pages[page];

export const getPublicSitePageRobots = (): PageRobotsPolicy =>
  isPublicSiteSeoEnabled() ? 'index,follow' : 'noindex,follow';
